<template>
  <form @submit.prevent="submitForm">
    <FormField
      id="Nombre"
      label="Nombre"
      type="text"
      v-model="formData.Nombre"
      :required="true"
      :maxlength="100"
      helpText="Nombre del registro (máximo 100 caracteres)"
    />
    
    <FormField
      id="Email"
      label="Email"
      type="email"
      v-model="formData.Email"
      :maxlength="100"
      helpText="Dirección de correo electrónico (opcional)"
    />
    
    <FormField
      id="EsActivo"
      label="Estado"
      type="checkbox"
      v-model="formData.EsActivo"
      checkboxLabel="Registro activo"
      helpText="Indica si el registro está activo en el sistema"
    />
    
        <FormField 
          id="FechaInserta" 
          label="Fecha de Inserción" 
          type="text" 
          v-model="formData.FechaInserta" 
          :disabled="true"
          helpText="Fecha y hora de inserción del registro (se establece automáticamente)"
        />
    
    <FormField
      id="Peso"
      label="Peso"
      type="number"
      v-model="formData.Peso"
      step="0.01"
      min="0"
      max="99999999.99"
      helpText="Peso del registro (decimal con 2 decimales)"
    />
    
    <div class="d-flex gap-2 mt-4">
      <button type="button" class="btn btn-primary" :disabled="loading" @click="submitForm">
        <span v-if="loading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
        <i v-else class="bi bi-save me-1"></i>
        {{ isEditing ? 'Actualizar' : 'Guardar' }}
      </button>
      <button type="button" class="btn btn-secondary" @click="$emit('cancel')">
        <i class="bi bi-x-circle me-1"></i> Cancelar
      </button>
    </div>
  </form>
</template>

<script>
import FormField from '@/shared/components/FormField.vue';

export default {
  name: 'DemoCrudCharForm',
  components: {
    FormField
  },
  props: {
    registro: {
      type: Object,
      default: () => ({
        DemoChar: '',
        Nombre: '',
        Email: '',
        EsActivo: true,
        FechaInserta: '',
        Peso: null
      })
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: { ...this.registro }
    };
  },
  watch: {
    registro: {
      handler(newValue) {
        this.formData = { ...newValue };
        // Formatear fecha para mostrar en formato local
        if (this.formData.FechaInserta) {
          const date = new Date(this.formData.FechaInserta);
          if (!isNaN(date.getTime())) {
            this.formData.FechaInserta = date.toLocaleString('es-MX', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: true
            });
          }
        } else if (!this.isEditing) {
          // Para nuevos registros, establecer fecha actual automáticamente
          // El código se generará en el submitForm basado en los registros existentes
          const now = new Date();
          this.formData.FechaInserta = now.toLocaleString('es-MX', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true
          });
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    generateCode(registros) {
      // Generar código secuencial basado en los registros existentes
      if (!registros || registros.length === 0) {
        return '1';
      }
      
      // Encontrar el número más alto en los códigos existentes
      let maxNumber = 0;
      registros.forEach(registro => {
        const code = registro.DemoChar;
        if (code && !isNaN(code)) {
          const num = parseInt(code);
          if (num > maxNumber) {
            maxNumber = num;
          }
        }
      });
      
      return (maxNumber + 1).toString();
    },
    submitForm() {
      // Preparar datos para envío
      const dataToSubmit = { ...this.formData };
      
      // Si es un nuevo registro, generar código secuencial
      if (!this.isEditing && !dataToSubmit.DemoChar) {
        // Obtener los registros actuales del servicio padre
        const registros = this.$parent.service?.registros || [];
        dataToSubmit.DemoChar = this.generateCode(registros);
      }
      
      // Convertir fecha si existe
      if (dataToSubmit.FechaInserta) {
        // Si es un nuevo registro, usar la fecha actual
        if (!this.isEditing) {
          dataToSubmit.FechaInserta = new Date().toISOString();
        } else {
          // Para edición, mantener la fecha original o usar la actual si no hay fecha
          try {
            const date = new Date(dataToSubmit.FechaInserta);
            if (!isNaN(date.getTime())) {
              dataToSubmit.FechaInserta = date.toISOString();
            } else {
              dataToSubmit.FechaInserta = new Date().toISOString();
            }
          } catch (error) {
            dataToSubmit.FechaInserta = new Date().toISOString();
          }
        }
      } else {
        // Si no hay fecha, establecer la actual
        dataToSubmit.FechaInserta = new Date().toISOString();
      }
      
      // Convertir peso a número si existe
      if (dataToSubmit.Peso !== null && dataToSubmit.Peso !== '') {
        dataToSubmit.Peso = parseFloat(dataToSubmit.Peso);
      } else {
        dataToSubmit.Peso = null;
      }
      
      this.$emit('submit', dataToSubmit);
    }
  }
};
</script>

<style scoped>
/* Estilos específicos del formulario si son necesarios */
</style>
